import * as Sentry from "@sentry/browser"
import {
  ReportingObserver as ReportingObserverIntegration,
  CaptureConsole as CaptureConsoleIntegration,
} from "@sentry/integrations"

const sentryElement: HTMLElement = document.querySelector("[data-js-sentry]")

if (sentryElement) {
  const sentryData = JSON.parse(`${sentryElement.dataset.jsSentry}`)

  Sentry.init({
    dsn: sentryData.dsn,
    integrations: [new ReportingObserverIntegration(), new CaptureConsoleIntegration({
      levels: ["error", "debug"],
    })],
    environment: sentryData.environment,
    release: sentryData.release,
  })

  Sentry.setTag("customer", sentryData.customer);
}
